const styles = theme => ({
  root: {
    gridColumnStart: 2,
    padding: theme.spacing(5, 0),
  },

  scorecardwrp: {
    padding: '24px 0 40px',
  },

  /* ----------------------------- Page Header ----------------------------- */

  pageHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '24px',
    marginBottom: '36px',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },

  pageTitle: {
    margin: 0,
    color: '#000',
    fontSize: '36px',
    lineHeight: 1.2,
    fontFamily: 'VodafoneRg-bold',

    [theme.breakpoints.down('sm')]: {
      fontSize: '28px',
    },
  },

  pageSubTitle: {
    margin: '10px 0 0',
    color: '#8b8b8b',
    fontSize: '18px',
    fontFamily: 'VodafoneRg-Regular',
  },

  headerActions: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',

    [theme.breakpoints.down('sm')]: {
      width: '100%',
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },

  searchBox: {
    width: '290px',
    height: '48px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '0 14px',
    border: '1px solid #E2E2E2',
    borderRadius: '10px',
    background: '#fff',

    [theme.breakpoints.down('sm')]: {
      width: '100%',
      boxSizing: 'border-box',
    },
  },

  searchIcon: {
    color: '#8f8f8f',
    fontSize: '22px',
    lineHeight: 1,
  },

  searchInput: {
    width: '100%',
    border: 0,
    outline: 0,
    color: '#222',
    fontSize: '16px',
    fontFamily: 'VodafoneRg-Regular',

    '&::placeholder': {
      color: '#999',
    },
  },

  sortSelect: {
    height: '48px',
    minWidth: '190px',
    padding: '0 14px',
    border: '1px solid #E2E2E2',
    borderRadius: '10px',
    background: '#fff',
    color: '#111',
    fontSize: '16px',
    fontFamily: 'VodafoneRg-Regular',
    cursor: 'pointer',

    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },

  newQuestionnaireBtn: {
    height: '48px',
    minWidth: '190px',
    padding: '0 20px',
    borderRadius: '10px',
    background: '#4C7DFF',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
    fontSize: '16px',
    fontFamily: 'VodafoneRg-bold',
    transition: 'all 300ms ease',

    '&:hover': {
      background: '#2E63F6',
      color: '#fff',
      textDecoration: 'none',
    },

    [theme.breakpoints.down('sm')]: {
      width: '100%',
      boxSizing: 'border-box',
    },
  },

  /* ----------------------------- Grid ----------------------------- */

  templateCols: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    gap: '28px',

    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    },

    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
    },
  },

  /* ----------------------------- Card ----------------------------- */

  scorecardItem: {
    position: 'relative',
    background: '#fff',
    border: '1px solid #E5E5E5',
    borderRadius: '14px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
    overflow: 'hidden',
    padding: '28px 28px 24px',
    minHeight: '200px',
    boxSizing: 'border-box',
    transition: 'all 300ms ease',

    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 8px 22px rgba(0,0,0,0.12)',
    },
  },

  cardTopBorder: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '5px',
    background: '#4C7DFF',
  },

  cardHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: '18px',
    marginBottom: '28px',
  },

  scorecardName: {
    margin: 0,
    color: '#000',
    fontSize: '22px',
    lineHeight: 1.25,
    fontFamily: 'VodafoneRg-bold',
    maxWidth: '70%',

    [theme.breakpoints.down('xs')]: {
      maxWidth: '100%',
      fontSize: '20px',
    },
  },

  actionWrap: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flexShrink: 0,

    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'flex-end',
    },
  },

  btns: {
    minHeight: '34px',
    padding: '7px 13px',
    borderRadius: '9px',
    fontSize: '15px',
    lineHeight: 1,
    fontFamily: 'VodafoneRg-Regular',
    textDecoration: 'none',
    cursor: 'pointer',
    boxSizing: 'border-box',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',
    transition: 'all 300ms ease',
    marginBottom:'8px',
    marginRight:'0px'
  },

  btnIcon: {
    fontSize: '15px',
    lineHeight: 1,
  },

  cloneBtn: {
    background: '#fff',
    color: '#000',
    border: '1px solid #DDDDDD',

    '&:hover': {
      background: '#F7F7F7',
      color: '#000',
      textDecoration: 'none',
    },
  },

  editBtn: {
    border: '1px solid #4C7DFF',
    background: '#4C7DFF',
    color: '#fff',

    '&:hover': {
      background: '#2E63F6',
      borderColor: '#2E63F6',
      color: '#fff',
      textDecoration: 'none',
    },
  },

  /* ----------------------------- Status Row ----------------------------- */

  statusRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '24px',
    marginBottom: '22px',
  },

  status: {
    display: 'flex',
    alignItems: 'center',
    gap: '9px',
    color: '#3775FF',
    fontSize: '16px',
    fontFamily: 'VodafoneRg-Regular',
  },

  statusDot: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    background: '#3775FF',
    display: 'inline-block',
  },

  responseCount: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    color: '#8E8E8E',
    fontSize: '16px',
    fontFamily: 'VodafoneRg-Regular',
  },

  responseIcon: {
    color: '#8E8E8E',
    fontSize: '16px',
  },

  divider: {
    width: '100%',
    height: '1px',
    background: '#EDEDED',
    marginBottom: '24px',
  },

  /* ----------------------------- Footer ----------------------------- */

  avtarContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '18px',
    width: '100%',
  },

  imgblock: {
    flexShrink: 0,
  },

  noimg: {
    display: 'block',
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    background: '#EEEEEE',
    objectFit: 'cover',
  },

  avtarDetails: {
    minWidth: 0,
    flex: 1,
  },

  ownerName: {
    color: '#000',
    fontSize: '18px',
    lineHeight: 1.3,
    fontFamily: 'VodafoneRg-bold',
    marginBottom: '6px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  dateRow: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '12px',
  },

  dateText: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '5px',
    color: '#8F8F8F',
    fontSize: '15px',
    fontFamily: 'VodafoneRg-Regular',
  },

  dateIcon: {
    color: '#8F8F8F',
    fontSize: '13px',
  },

  /* ----------------------------- Empty State ----------------------------- */

  noFoundtemplateAreaWpr: {
    gridColumn: '1 / -1',
    textAlign: 'center',
    margin: '2rem 0',
    padding: '48px 24px',
  },

  notFoundImg: {
    maxWidth: '25rem',
    width: '100%',
    margin: '2rem auto',
    display: 'block',
  },

  notFoundContent: {
    margin: 0,
    fontSize: '2.125rem',
    fontFamily: 'VodafoneRg-bold',
  },

  notFoundContentSmall: {
    margin: '8px 0 0',
    color: '#777',
    fontSize: '1rem',
    fontFamily: 'VodafoneRg-Regular',
  },
});

export default styles;